export const CartItemDeliveryStatus = ({
  status,
  isImmediateDelivery,
}: {
  status: string;
  isImmediateDelivery: boolean;
}) => {
  return (
    <div
      className={`${isImmediateDelivery ? "bg-[#D8EDD3] text-[#383838] inline px-2 py-1" : "bg-[#FEE8D8] text-[#383838] inline px-2 py-1"}`}
    >
      {status}
    </div>
  );
};
